import React from 'react'
import PropTypes from 'prop-types'
import IconLabel from './IconLabel'
import {RightSquareFilled} from '@ant-design/icons'

const SlideshowProduct = ({product}) => {
  const variants = {
    slideshow: 'SoMe',
  }

  const {slideshowVariant} = product
  const variantLabel = variants[slideshowVariant] || slideshowVariant

  return (
    <div className="selected-product-options SlideshowProduct">
      <IconLabel icon={<RightSquareFilled />} label={variantLabel} />
    </div>
  )
}

SlideshowProduct.propTypes = {
  product: PropTypes.object.isRequired,
}

export default SlideshowProduct
